import { Capacitor } from "@capacitor/core";
import { redirect, useLoaderData } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { get } from "api";
import { Button } from "atoms/button/Button";
import { Icon } from "atoms/icon/Icon";
import Warning from "atoms/icon/icons/ic_warning_ol.svg";
import { queryClient } from "pages/Root";
import Services from "services/Services";
import { waitObj } from "toolbox/Promise";
import { defineLoader } from "toolbox/Router";
import { useLogout } from "utils/useLogout";

type LoaderData = Awaited<ReturnType<typeof deactivatedLoader>>;
export const deactivatedLoader = defineLoader(async () => {
  const platform = await queryClient.ensureQueryData({
    queryKey: ["/platform/current"],
    queryFn: () => get("/platform/current").catch(() => null),
  });

  if (!platform || platform?.active) {
    throw redirect("/home");
  }

  return waitObj({ platform });
});

export const Deactivated = () => {
  const navigate = useNavigate();
  const { platform } = useLoaderData() as LoaderData;
  const logout = useLogout();

  // When a platform is deactivated, we want to force the user's token to get
  // reset in case we reassign the domain later to a different platform
  if (!Capacitor.isNativePlatform()) {
    Services.auth.clearAll();
  }

  return (
    <div className="flex h-screen flex-col p-4 pt-[calc(56px_+_env(safe-area-inset-top))]">
      <div className="flex flex-grow flex-col items-center">
        <div className="mb-8">
          <Icon svg={Warning} size="large" color="red" />
        </div>
        <div className="text-body mx-4 mb-8 text-center">
          The <span className="font-bold">{platform.name}</span> app has been
          deactivated. Please contact the business with any questions you may
          have.
        </div>
      </div>
      {Capacitor.isNativePlatform() && (
        <div className="sticky bottom-0 mb-8 flex w-full flex-col gap-2">
          <Button onClick={() => navigate("/change-location")} fullWidth>
            Change location
          </Button>
          <Button fullWidth={true} style="secondary" onClick={logout}>
            Logout
          </Button>
        </div>
      )}
    </div>
  );
};
